import { isAfter, isBefore, isWithinInterval } from 'date-fns';
import newTZDate, { todayDate } from './dateHelpers';

const isValidDate = (date: Date) => date instanceof Date && !Number.isNaN(date.getTime());
const defaultStatus = { snoozeActive: false, snoozeScheduled: false };

/*
  `snooze_start_date` and `snooze_end_date` appear in two different formats:
  - When retrieved from search, it's in GMT to accommodate renters across different time zones
    e.g. "2023-10-10T00:00:00+02:00"
  - When from listing APIs, it contains only the date for owners, as the time is assumed to match
    the listing's timezone e.g. "2023-10-10T00:00:00Z"
*/
const getSnoozeStatus = (
  startDate: string | undefined,
  endDate: string | undefined,
  withTimeZone?: boolean,
): { snoozeActive: boolean; snoozeScheduled: boolean } => {
  if (!startDate || !endDate) return defaultStatus;
  const today = withTimeZone ? new Date() : todayDate();
  const start = withTimeZone ? new Date(startDate) : newTZDate(startDate);
  const end = withTimeZone ? new Date(endDate) : newTZDate(endDate);

  if (!isValidDate(start) || !isValidDate(end)) return defaultStatus;

  const snoozeScheduled = startDate ? isAfter(start, today) : false;
  const snoozeActive = endDate && !isBefore(end, start)
    ? isWithinInterval(today, { start, end }) : false;

  return { snoozeActive, snoozeScheduled };
};

export default getSnoozeStatus;
